import { Link } from "gatsby"
import React from "react"

export default function MenuButton({ children, to }) {
  return <div className="ezds-menu-button"><Link className="ezds-menu-button-link" to={to} activeClassName="ezds-menu-button-link--active">{children}</Link></div>
}
